import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'adStatusPipe'
})
export class AdStatusPipe implements PipeTransform {
  private listObj: any = {
    0: 'Pending',
    1: 'Active',
    2: 'Expired',
    3: 'Deactived',
    4: 'Archived',
  };


  transform(value: number): string {
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
